import { z } from "zod/v4";
import { bptFutureSchema } from "../../schemas/bis";
import { fetchApi } from "../client/internal";

export const futures = {
	list: () => fetchApi(`/futures`, z.array(bptFutureSchema)),
	get: (id: string) => fetchApi(`/futures/${id}`, bptFutureSchema),
	create: (body: any) =>
		fetchApi(`/futures`, bptFutureSchema, { method: "POST", body: JSON.stringify(body) }),
	update: (id: string, body: any) =>
		fetchApi(`/futures/${id}`, bptFutureSchema, { method: "PUT", body: JSON.stringify(body) }),
	remove: (id: string) =>
		fetchApi(`/futures/${id}`, z.object({ deleted: z.boolean() }), { method: "DELETE" }),
};
